import * as Styled from "./styled";

import zones from "./assets/ic_zone_premium.png";
import Modal from "../../../Modal";

function About(props) {
  return (
    <>
      <Modal onClose={props.onClose}>
        <Styled.Container>
          <Styled.TitleText>What are the Land Zones?</Styled.TitleText>
          <Styled.InfoWrapper>
            <Styled.InfoIcon src={zones} />
            <Styled.InfoText>The Zone determines the rarity of the Land.</Styled.InfoText>
          </Styled.InfoWrapper>
          <Styled.AccentText>How Imversed Lands are determined</Styled.AccentText>
          <Styled.DisclaimerText>
            Land Zones are predetermined before they are Minted, and are assigned based on the closure to the city
            center.
          </Styled.DisclaimerText>
          <Styled.DisclaimerText>
            City center is connected to a physical location. Therefore, the closer a Land is to a city centers, the
            lower the Zone.
          </Styled.DisclaimerText>
          <Styled.AccentText>Zone distribution in a city</Styled.AccentText>
          <Styled.DisclaimerText>Here is the Zone distribution of a city:</Styled.DisclaimerText>
          <Styled.AccentText>How Land Zones affect Mint pricing</Styled.AccentText>
          <Styled.DisclaimerText>The higher the Zone, the higher the Mint price.</Styled.DisclaimerText>
        </Styled.Container>
      </Modal>
    </>
  );
}

export default About;
